enum ProtectionStatus {
  Protected = 'protected',
  Unprotected = 'unprotected',
}
export default ProtectionStatus;
